import * as Rest from "../../Generated/RestClient";
import { FlagUtility } from "./FlagUtility";
import { clientAppSettings } from "../../Models/ClientAppSettings";

/**
 * Utility to check for supported features.
 */
export class SupportedFeatureUtility {
    public static isSupported(feature: Rest.DevPortalFeatureFlags): boolean {
        return FlagUtility.hasFlag(clientAppSettings.enabledFeatures, feature);
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Utility/SupportedFeatureUtility.ts